import { Search, X } from "lucide-react";
import { useRef, useEffect } from "react";
import { Input } from "../../../../../components/UI/Input";

const SearchInput = ({
  searchQuery,
  setSearchQuery,
  autoFocus = false,
  showShortcut = false,
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (autoFocus) {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 100);
    }
  }, [autoFocus]);

  const clearSearch = () => {
    setSearchQuery("");
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  return (
    <div className="relative">
      <Search
        className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
        size={18}
      />
      <Input
        ref={inputRef}
        placeholder="Tìm kiếm"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="pl-10 py-2 text-base h-12 border rounded-full border-gray-300 bg-gray-50/50"
      />
      {searchQuery && (
        <button
          onClick={clearSearch}
          className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Xóa"
        >
          <X size={18} />
          <span className="sr-only">Xóa</span>
        </button>
      )}
      {!searchQuery && showShortcut && (
        <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
          <kbd className="text-xs font-medium text-gray-400 bg-gray-100 px-1.5 py-0.5 rounded">
            {navigator.platform.indexOf("Mac") > -1 ? "⌘K" : "Ctrl+K"}
          </kbd>
        </div>
      )}
    </div>
  );
};

export default SearchInput;
